<app-generic-container>
    <!-- Usamos el panel genérico -->
    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">
        <dx-data-grid #dataGrid id="gridContainer" [dataSource]="dataSource"
            (onEditorPreparing)="onEditorPreparing($event)">

            <!-- Definición de las columnas -->

            <dxi-column dataField="name" caption="Nombre de la empresa" alignment="center"></dxi-column>
            <dxi-column dataField="workCentersAmount" caption="Número de centros" alignment="center"></dxi-column>

            <!-- Templates -->
            <ng-container>
                <dxi-column dataField="company1" caption="Acciones" [allowFiltering]="false" [allowSorting]="false"
                    alignment="center" cellTemplate="buttonCRUDTemplate"></dxi-column>
                <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
                    <button rel="tooltip" type="button" class="btn btn-success btn-action"
                        (click)="onClickEdit(data.data)">
                        <i class="material-icons">edit</i>
                    </button>
                </ng-container>
            </ng-container>


        </dx-data-grid>

    </app-generic-panel>

    <br>
</app-generic-container>